<template>
    <div id="setup-tab-first-pay-container">
        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.ApiUrlCri')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'apiUrlGetCriptograma'"
                    v-bind:MaxLengthProp="600"
                    v-model="editableItem.apiUrlGetCriptograma"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_apiUrlGetCriptograma'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.ApiUrlTrans')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'apiUrlTransaction'"
                    v-bind:MaxLengthProp="500"
                    v-model="editableItem.apiUrlTransaction"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_apiUrlTransaction'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.Merchantkey')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_merchantKey'"
                    v-bind:MaxLengthProp="60"
                    v-model="editableItem.merchantKey"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_merchantKey'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.ProcessorId')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_processorId'"
                    v-bind:MaxLengthProp="10"
                    v-model="editableItem.processorId"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_processorId'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.TransactionCenterId')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_TransactionCenterId'"
                    v-bind:MaxLengthProp="16"
                    v-model="editableItem.transactionCenterId"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_TransactionCenterId'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TabSetupNab',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        const defaultItemData = {
            apiUrlGetCriptograma: '',
            apiUrlTransaction: '',
            merchantKey: '',
            processorId: '',
            transactionCenterId: ''
        };
        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        }
    }
};
</script>
